import React, { useState } from "react";
import Dialog from "../Dialog";
import styled from "styled-components";
import Button from "../Button";

const EventBannerShopDialog = () => {
  const [open, setOpen] = useState(false);

  const bannerCards = [
    {
      title: "Commander Captain",
      timeRemaining: "21h",
      price: 10000,
      showBuyButton: false,
    },
    {
      title: "Commander Captain",
      timeRemaining: "21h",
      price: 10000,
      showBuyButton: true,
    },
    {
      title: "Commander Captain",
      timeRemaining: "21h",
      price: 10000,
      showBuyButton: true,
    },
  ];

  return (
    <Dialog open={open} onClose={() => setOpen(false)} size="xl">
      <ShopContainer>
        <ShopTitle src="/images/main-title5.png" alt="Event Banner Shop" />
        <CardsContainer>
          {bannerCards.map((card, index) => (
            <BannerCard key={index}>
              <CardHeader>
                <img
                  src={"/assets/images/sample-image.png"}
                  className="w-100"
                />
              </CardHeader>
              <TimeRemaining>
                <Timer />
                <span>{card.timeRemaining}</span>
              </TimeRemaining>
              <CardContent>
                <div className="d-flex flex-wrap gap-2">
                  {/* Each grid of 9 items would have item images here */}
                  {Array(9)
                    .fill(0)
                    .map((_, i) => (
                      <div className="item-frame" style={{width:60,height:60}} key={i}>
                        {i < 4 && (
                          <ItemImage
                            src={`/images/item-${i + 1}.png`}
                            alt={`Item ${i + 1}`}
                          />
                        )}
                      </div>
                    ))}
                </div>
              </CardContent>
              {card.showBuyButton && (
                <Button variant="primary">
                  <CoinIcon />
                  <span>{card.price}</span>
                </Button>
              )}
            </BannerCard>
          ))}
        </CardsContainer>

        <Pagination>
          <PaginationDot active />
          <PaginationDot />
          <PaginationDot />
        </Pagination>
      </ShopContainer>
    </Dialog>
  );
};

const Timer = () => {
  return (
    <svg
      width="7"
      height="8"
      viewBox="0 0 7 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.07451 2.63427C1.76373 2.35289 1.58594 1.9497 1.58594 1.53112V1.04395H5.29157V1.53112C5.29157 1.9497 5.11378 2.35289 4.80299 2.63427L3.43805 3.87462L2.07311 2.63427H2.07451Z"
        fill="#FFEBCC"
      />
      <path
        d="M4.89063 1.44529V1.53209C4.89063 1.83867 4.76043 2.13266 4.53364 2.33845L3.43747 3.33381L2.34131 2.33845C2.11452 2.13266 1.98435 1.83867 1.98435 1.53209V1.44529H4.88923M5.69139 0.644531H1.18359V1.53209C1.18359 2.06546 1.40897 2.57364 1.80236 2.93203L3.43607 4.41736L5.06979 2.93203C5.46457 2.57364 5.68859 2.06546 5.68859 1.53209V0.644531H5.69139Z"
        fill="#FFEBCC"
      />
      <path
        d="M3.43611 4.59094L4.53227 5.58629C4.75906 5.79208 4.88926 6.08607 4.88926 6.39266V6.59566H1.98439V6.39266C1.98439 6.08607 2.11456 5.79208 2.34135 5.58629L3.43751 4.59094M3.43611 3.50879L1.80239 4.99412C1.40761 5.3525 1.18359 5.86068 1.18359 6.39406V7.39782H5.69142V6.39406C5.69142 5.86068 5.46601 5.3525 5.07263 4.99412L3.43891 3.50879H3.43611Z"
        fill="#FFEBCC"
      />
      <path d="M6.25444 0.5H0.621094V1.32737H6.25444V0.5Z" fill="#FFEBCC" />
      <path
        d="M6.25444 6.67285H0.621094V7.50022H6.25444V6.67285Z"
        fill="#FFEBCC"
      />
    </svg>
  );
};
// Styled components to match the Figma design
const ShopContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 20px 0;
`;

const ShopTitle = styled.img`
  width: 338px;
  height: 45px;
  margin-bottom: 20px;
`;

const CardsContainer = styled.div`
  display: flex;
  gap: 28px;
  justify-content: center;
  margin: 20px 0;
`;

const BannerCard = styled.div`
  width: 208px;
  height: 395px;
  background-color: #32251f;
  border: 1px solid #f9e88d;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const CardHeader = styled.div`
  height: 104px;
  background: linear-gradient(to bottom right, #26231a, rgba(92, 49, 46, 0.5));
  position: relative;
  border-bottom: 1px solid #5b5245;
  border-radius: 6px 6px 0 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: 3px;
`;

const CardTitle = styled.div`
  font-size: 14px;
  background: linear-gradient(
    to right,
    #f1a117,
    #fbcf84,
    #f1a117,
    #ffea8d,
    #f1a117,
    #f8d332
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-align: center;
  font-weight: bold;
  margin-top: 3px;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.25);
  -webkit-text-stroke: 0.7px #302721;
`;

const TimeRemaining = styled.div`
  display: flex;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  padding: 0 5px;
  color: #ebeacc;
  font-size: 12px;
  gap: 3px;
  margin-top: 9px;
  margin-bottom: 9px;
  width: fit-content;
  margin-inline: auto;
`;

const ClockIcon = styled.div`
  width: 12px;
  height: 12px;
  background-color: #ebeacc;
  mask: url("/images/clock-icon.svg") no-repeat center / contain;
  -webkit-mask: url("/images/clock-icon.svg") no-repeat center / contain;
`;

const CardContent = styled.div`
  padding: 10px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`;

const ItemGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, 1fr);
  gap: 4px;
  margin-top: 10px;
`;

const ItemSlot = styled.div`
  position: relative;
  width: 60px;
  height: 64px;
  background-image: url("/images/item-frame.png");
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ItemImage = styled.img`
  width: 53px;
  height: 53px;
  object-fit: contain;
`;

const CoinIcon = styled.div`
  width: 23px;
  height: 23px;
  background-image: url("/images/coin-icon.png");
  background-size: contain;
`;

const Pagination = styled.div`
  display: flex;
  gap: 5px;
  margin-top: 10px;
`;

const PaginationDot = styled.div<{ active?: boolean }>`
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background-color: ${(props) => (props.active ? "#262221" : "#131313")};
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  &::after {
    content: "";
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background-color: ${(props) => (props.active ? "#47403a" : "#47403a")};
  }
`;

export default EventBannerShopDialog;
